import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=205169a0&scoped=true&"
import script from "./AddCard.vue?vue&type=script&lang=ts&"
export * from "./AddCard.vue?vue&type=script&lang=ts&"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=205169a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205169a0",
  null
  
)

export default component.exports